var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:{'cursor-pointer': _vm.id&&_vm.rep, 'text-primary': _vm.id&&_vm.rep},on:{"click":_setup.onClick}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s((_vm.id&&_vm.rep)?_vm.rep:_vm.empty)+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }